import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const buttonColorOptions = [
  Colors.primary.claytonBlue,
  Colors.secondary.kiddiePool,
  Colors.secondary.summerNight,
  Colors.accent.ladyBug,
  Colors.accent.cheesePuff,
  Colors.secondary.rubberDucky,
  Colors.primary.white,
];

const RadioButtonStyles = styled.div.attrs({ className: 'radio-button' })`
  label {
    align-items: center;
    color: ${Colors.accent.grey1.standard};
    cursor: pointer;
    display: flex;
    font-family: 'SourceSansPro', sans-serif;
    font-size: 14px;
    height: 22px;
    margin-left: 7px;
  }
  input[type='radio'] {
    -webkit-appearance: none;
    border-radius: 50%;
    border: 1px solid ${Colors.accent.grey2.standard};
    cursor: pointer;
    height: 16px;
    margin-right: 10px;
    margin-top: 0;
    width: 16px;
  }
  input[type='radio']:checked {
    background-color: ${Colors.primary.claytonBlue.standard};
    border: 1px solid ${Colors.primary.claytonBlue.standard};
  }
  input[type='radio']:hover {
    border: 1px solid ${Colors.primary.claytonBlue.standard};
  }
  input[type='radio']:disabled {
    border: 1px solid ${Colors.accent.grey4.standard} !important;
    background-color: transparent !important;
    cursor: not-allowed;
  }
  ${buttonColorOptions
    .map(
      (color) =>
        `&.${color.className} {
        input[type="radio"]:checked {
            background-color: ${color.standard};
            border: 1px solid ${color.standard};     
        }
        input[type="radio"]:hover {  
            border: 1px solid ${color.standard};     
        }             
    }`
    )
    .join('\n')}
  &.disabled {
    cursor: not-allowed;
  }
`;

export default RadioButtonStyles;
